export default __webpack_public_path__ + "static/media/loader.6404b994.gif";